import './AboutPage.css'
import { Link } from 'react-router-dom';
import HeroTitle from '../../layouts/HeroTitle/HeroTitle';
function AboutPage() {
    return (
      <div className="about-page">
        <HeroTitle title="À PROPOS" />

        <section className="story-section">
          <div className="story-image">
            <img src='./images/roms_resto.jpg' alt="Notre restaurant" />
            <div className="story-badge">Depuis 2024</div>
          </div>
          <div className="story-content">
            <h2>Notre Histoire</h2>
            <div className="section-decoration"></div>
            <p>
            Nous sommes installés dans un lieu historiquement dédié à la restauration. On a créé un restaurant qui représente nos valeurs : chaleureux, moderne et ancré dans la tradition.
            </p>
            <p>
            Lucie est en cuisine, Romain en salle : on forme un duo complémentaire qui partage la même passion pour la bonne cuisine française et le contact humain.
            </p>
            <p>
            Le ToursBouillon propose une cuisine traditionnelle, simple et généreuse, dans un cadre dédié à la convivialité.
            </p>
          </div>
        </section>

        <section className="values-section">
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">🌱</div>
              <h3>Terroir</h3>
              <p>Des produits locaux sélectionnés avec soin auprès de nos producteurs partenaires.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">👨‍🍳</div>
              <h3>Savoir-faire</h3>
              <p>Une cuisine authentique qui respecte les traditions tout en les réinventant.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">🍷</div>
              <h3>Passion</h3>
              <p>Une sélection pointue de vins qui sublime chaque plat.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">🤝</div>
              <h3>Convivialité</h3>
              <p>Un service attentionné dans une ambiance chaleureuse.</p>
            </div>
          </div>
        </section>

        <section className="specialties-section">
          <h2>Nos Spécialités</h2>
          <div className="section-decoration"></div>
          <div className="specialties-carousel">
            <Link to="/menu" className="specialty-card">
              <div className="specialty-image">
                <img src='./images/about_wine_cave.jpg' alt="Notre cave à vins" />
              </div>
              <div className="specialty-content">
                <h3>Notre Cave</h3>
                <p>Une sélection raffinée des meilleurs vins de la région</p>
              </div>
            </Link>
            <Link to="/menu" className="specialty-card">
              <div className="specialty-image">
                <img src='./images/about_page_terroir.jpg' alt="Nos plats" />
              </div>
              <div className="specialty-content">
                <h3>Cuisine du Terroir</h3>
                <p>Des plats traditionnels revisités avec élégance</p>
              </div>
            </Link>
            {/* <Link to="/menu" className="specialty-card">
              <div className="specialty-image">
                <img src='./images/about_page_patisseries.jpg' alt="Nos desserts" />
              </div>
              <div className="specialty-content">
                <h3>Pâtisseries</h3>
                <p>Des créations sucrées qui éveillent les sens</p>
              </div>
            </Link> */}
          </div>
        </section>
      </div>
    );
}

export default AboutPage;